export default __webpack_public_path__ + "static/media/bubble_icon.a05fd57f.svg";